'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transparencySwiper = function transparencySwiper(element) {
  _classCallCheck(this, transparencySwiper);

  this.element = element;
  this.slideLength = this.element.querySelectorAll('.js-transparencySwiper_node').length;
  this.slidesPerView = 1;
  this.slidesPerGroup = 1;
  this.options = {
    // loop: true,
    slidesPerView: this.slidesPerView,
    slidesPerGroup: this.slidesPerGroup,
    spaceBetween: 15,
    navigation: {
      nextEl: this.element.querySelector('.swiper-button-next'),
      prevEl: this.element.querySelector('.swiper-button-prev')
    },
    pagination: {
      el: '.js-transparencyPagenation',
      type: 'fraction'
    }
  };
  this.swiper = new Swiper(this.element, this.options);
};

document.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('.js-transparencySwiper');
  swipers.forEach(function (element) {
    new transparencySwiper(element);
  });
});